import { Component } from '@angular/core';

@Component({
    selector: 'modal-body',
    styles: [
        `
        :host {
            flex: 1 1 auto;
            overflow-y: auto;
            background: white;
            padding: 1rem;
        }

        @media (max-width: 512px) {
            :host {
                padding: 0;
            }
        }
        `,
    ],
    template: `
        <ng-content></ng-content>
    `,
})
export class ModalBodyComponent {}
